import React, {useState, useRef} from "react";
import axios from 'axios';
import "./App.css";
import ReCAPTCHA from 'react-google-recaptcha';
import useVisitorTracking from './hooks/useVisitorTracking';

const App = () => {
    const [formData, setFormData] = useState({name: '', email: ''});
    const [captchaToken, setCaptchaToken] = useState(null);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'error', 'loading'
    const recaptchaRef = useRef(null);
    const { trackEvent } = useVisitorTracking();

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
        // Track form interaction
        trackEvent('form_field_interaction', {
            field: e.target.name,
            label: `${e.target.name}_field_focus`
        });
    };

    const handleCaptcha = (token) => {
        setCaptchaToken(token); // Atualiza o token quando o captcha é resolvido
        trackEvent('captcha_completed', { success: !!token });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            setMessage('Por favor, resolva o reCAPTCHA.');
            setMessageType('error');
            trackEvent('form_submission_failed', { reason: 'missing_captcha' });
            return;
        }

        // Track form submission attempt
        trackEvent('form_submission_attempt', {
            hasName: !!formData.name,
            hasEmail: !!formData.email,
            label: 'tourism_signup_attempt'
        });

        setMessage('Enviando...');
        setMessageType('loading');

        try {
            console.log('Sending request to API:', {
                url: 'https://api.vaiagoraturismo.com.br/api/register',
                data: { ...formData, captchaToken: captchaToken ? 'present' : 'missing' }
            });

            const response = await axios.post('https://api.vaiagoraturismo.com.br/api/register', {
                ...formData,
                captchaToken,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
                timeout: 10000, // 10 second timeout
            });

            console.log('API Response:', response.data);
            setMessage(response.data.message || 'Cadastro realizado com sucesso!');
            setMessageType('success');
            setFormData({name: '', email: ''});
            setCaptchaToken(null); // Reseta o token do captcha após o envio

            // Reset reCAPTCHA
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }

            // Track successful conversion
            trackEvent('form_submission_success', {
                label: 'tourism_signup_success',
                value: 1
            });

        } catch (error) {
            console.error('API Error Details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                url: error.config?.url,
                timeout: error.code === 'ECONNABORTED'
            });

            let errorMessage = 'Erro ao cadastrar. ';

            if (error.code === 'ECONNABORTED') {
                errorMessage += 'Timeout - servidor não respondeu.';
            } else if (error.response?.status === 404) {
                errorMessage += 'Endpoint não encontrado (404).';
            } else if (error.response?.status === 500) {
                errorMessage += 'Erro interno do servidor (500).';
            } else if (error.response?.status === 403) {
                errorMessage += 'Acesso negado (403).';
            } else if (error.response?.data?.message) {
                errorMessage += error.response.data.message;
            } else if (!navigator.onLine) {
                errorMessage += 'Verifique sua conexão com a internet.';
            } else {
                errorMessage += `Erro: ${error.message}`;
            }

            setMessage(errorMessage);
            setMessageType('error');
            trackEvent('form_submission_failed', {
                reason: 'api_error',
                error: error.response?.status || error.code || 'unknown',
                message: error.message
            });
        }
    };
    return (
        <div className="landing-page">
            {/* Logo */}
            <div className="logo-container">
                <img
                    src="/logo.png" // Caminho para o logotipo no public
                    alt="Vai Agora Turismo"
                    className="logo"
                />
            </div>

            {/* Texto principal */}
            <h1 className="title">
                Descubra destinos incríveis ao alcance de um clique!
            </h1>
            <p className="subtitle">
                Cadastre-se para receber ofertas exclusivas e dicas de viagem.
            </p>

            {/* Formulário */}
            <form className="form-container" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Seu nome"
                    className="input"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Seu e-mail"
                    className="input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <ReCAPTCHA
                    ref={recaptchaRef}
                    className="input"
                    sitekey="6LfUTvsrAAAAAFLkZp0WAjGjxYlrl5833Nlcxd1b"
                    onChange={handleCaptcha}
                />
                <button type="submit" className="submit-button">
                    Explore Agora
                </button>
                {message && (
                    <div className={`message ${messageType}`}>
                        {message}
                    </div>
                )}
            </form>
        </div>
    );
};

export default App;
